import { BookingFormBase } from "./utils";

export default class GeneralBookingForm extends BookingFormBase {
  constructor({
    managers,
    dateTimeManager,
    formSelector = "#the-general-booking-form",
    formType = "general",
  } = {}) {
    super(formSelector, {
      formType,
      dateTimeManager,
      managers,
    });

    if (!this.isActive) {
      return;
    }

    this.initBase();
    this.initRelationData();
  }

  initRelationData() {
    if (!HM_Variables.hospitals) {
      return;
    }

    const allHospitals = [...HM_Variables.hospitals];
    const availableHospitals = allHospitals.filter((hospital) => {
      const useExternalLink =
        hospital?.hospital_external_link?.use_external_link;
      return !useExternalLink;
    });
    const $form = this.$form;

    const $hospitalsSelect = $form.find("#hospitals-select-list");
    const $hospitalsInput = $form.find("input[name='booking-hospital']");

    $hospitalsSelect.html(
      availableHospitals
        .map((hospital) => {
          const shortName = hospital.hospital_shortname || "";
          const submissionId = hospital.hospital_id;
          return `<li class="option" data-value="${submissionId}" data-hospital="${shortName}">${hospital.title}</li>`;
        })
        .join("")
    );

    this.initDefaultValues(availableHospitals);

    $hospitalsInput.on("change", (e) => {
      const selectedHospitalId = $(e.target).val();
      if (!selectedHospitalId) {
        this.handleHospitalSelection(null);
        return;
      }

      const selectedHospital = availableHospitals.find(
        (hospital) =>
          String(hospital.hospital_id) ===
          String(selectedHospitalId)
      );
      if (!selectedHospital) {
        this.handleHospitalSelection(null);
        return;
      }

      this.handleHospitalSelection(selectedHospital);
    });
  }

  initDefaultValues(allHospitals) {
    if (
      typeof bookingFormVars === "undefined" ||
      !bookingFormVars.book_hospital
    ) {
      return;
    }

    const bookHospital = bookingFormVars.book_hospital;
    const selectedHospital = allHospitals.find(
      (hospital) => hospital.id == bookHospital
    );

    if (!selectedHospital) {
      return;
    }

    const $form = this.$form;
    const submissionId = selectedHospital.hospital_id;

    $form.find("input[name='booking-hospital']").val(submissionId);
    const $hospitalsCustomSelect = $form
      .find("#hospitals-select-list")
      .closest(".custom-select");
    const $hospitalsCurrentValue =
      $hospitalsCustomSelect.find(".current-value");
    $hospitalsCurrentValue
      .html(selectedHospital.title)
      .removeClass("default-value");

    $form.find("#hospitals-select-list .option").removeClass("active");
    $form
      .find(`#hospitals-select-list .option[data-value="${submissionId}"]`)
      .addClass("active");

    this.handleHospitalSelection(selectedHospital);
    this.applyUrlBookingPreselection();
  }
}
